export const actionTypes = {
	GET_ASSET_MEASUREMENT_HEALTH: 'operationalParameters/GET_ASSET_MEASUREMENT_HEALTH'
};
